import { useEffect } from 'react'

import { RemoveExtraClassesOfColorsDynamic } from './../../../utilities/BL/Games'


const Colors = ({ color }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")

            // Limpiar clases anteriores SIEMPRE
            await RemoveExtraClassesOfColorsDynamic()

            // Agregar clase nueva
            if (color) {
                document.body.classList.add(color)
                document.getElementById("fdmFooter")?.classList.add(color)
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [color])


    return (
        <div className="Colors">
            <p className="Colors__Icon Colors__Icon--LowOpacity"><i className="bi bi-phone-flip"></i></p>
            <p className="Colors__Title Colors__Title--LowOpacity">Sube el brillo y voltea tu celular para que la pantalla apunte hacia la cancha.</p>
            <p className="Colors__Title Colors__Title--LowOpacity">¡Disfruta la vista!</p>
        </div>
    )
}

export { Colors };